import { Component, Input } from '@angular/core';
import { UntypedFormControl } from '@angular/forms';

@Component({
  selector: 'form-group-pass',
  templateUrl: './form-group-pass.component.html',
  styleUrls: ['./form-group-pass.component.css']
})
export class FormGroupPassComponent {

  @Input() control: UntypedFormControl;
  @Input() id: string = '';
  @Input() title: string = '';
  @Input() placeholder: string = '';
  @Input() maxlength: number = 100;
  @Input() messageRequired: string = 'Información es requerida.';
  @Input() messagePattern: string = 'La contraseña no cumple con los requisitos mínimos.';
  @Input() showMessageHelp: boolean = false;

  public showPassword: boolean = false;

  constructor() { }



  passwordShow(): void {
    this.showPassword = !this.showPassword;
  }


}
